module.exports = __webpack_public_path__ + "static/media/connectguide2.d190657b.png";